"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAccessorialLegRef = exports.LoadAccessorialLeg = void 0;
var mobx_keystone_1 = require("mobx-keystone");
var OrderLeg_1 = require("./OrderLeg");
var LoadAccessorialLeg = /** @class */ (function (_super) {
    __extends(LoadAccessorialLeg, _super);
    function LoadAccessorialLeg() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRefId = function () { return "".concat(_this.id); };
        return _this;
    }
    LoadAccessorialLeg_1 = LoadAccessorialLeg;
    LoadAccessorialLeg.prototype.update = function (data) {
        var rootStore = (0, mobx_keystone_1.getRootStore)(this);
        if (!rootStore) {
            return;
        }
        var result = LoadAccessorialLeg_1._formatData(rootStore, data);
        if (result) {
            Object.assign(this, result);
        }
    };
    var LoadAccessorialLeg_1;
    LoadAccessorialLeg._formatData = function (rootStore, data) {
        var loadAccessorialLeg = __assign({}, data);
        try {
            loadAccessorialLeg.leg = (0, OrderLeg_1.orderLegRef)("".concat(data.leg));
            return loadAccessorialLeg;
        }
        catch (error) {
            console.warn('[WARN] error', error);
            return null;
        }
    };
    LoadAccessorialLeg.create = function (rootStore, data) {
        var result = LoadAccessorialLeg_1._formatData(rootStore, data);
        if (result) {
            return new LoadAccessorialLeg_1(result);
        }
        else {
            return null;
        }
    };
    __decorate([
        mobx_keystone_1.modelAction
    ], LoadAccessorialLeg.prototype, "update", null);
    LoadAccessorialLeg = LoadAccessorialLeg_1 = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/LoadAccessorialLeg')
    ], LoadAccessorialLeg);
    return LoadAccessorialLeg;
}((0, mobx_keystone_1.Model)({
    id: (0, mobx_keystone_1.prop)(),
    leg: (0, mobx_keystone_1.prop)(),
    percentage: (0, mobx_keystone_1.prop)(),
})));
exports.LoadAccessorialLeg = LoadAccessorialLeg;
exports.loadAccessorialLegRef = (0, mobx_keystone_1.rootRef)('doc-mate/LoadAccessorialLegRef', {
    getId: function (target) {
        if (target instanceof LoadAccessorialLeg) {
            return "".concat(target.id);
        }
    },
});
